export const blueToBlue = ['#00ffff', '#0098ed', '#005cd9']
export const blueToPurple = ['#005cd9', '#8616ad', '#ff0386']
export const pinkToYellow = ['#ff0386', '#ff9e74', '#fee140']
export const pinkToBeige = ['#ff0386', '#ff9bc6', '#ff9e74']
export const yellowToOrange = ['#fee140', '#ff8a32', '#ff2525']

export const yellowToBlue = ['#b4d432', '#3487cd']
export const brownToBlue = ['#259dad', '#c96b2b']
export const aquamarineToPurple = ['#a659b9', '#5ac59d']
export const salmonToPink = ['#c4a996', '#cab2c8']
export const pinkToOrange = ['#dd9912', '#e488be']
export const beigeToGreen = ['#14cd48', '#d8d395']
export const blueToAquamarine = ['#3a2733', '#11bba9']
export const roseToPinkish = ['#ebe4c5', '#d87961']
export const greenToBlue = ['#6197c3', '#6ad43d']
export const redToGreen = ['#298b70', '#cd0033']
export const beigeToPurple = ['#ce9446', '#958aac']
export const violetToPurple = ['#3b2334', '#ccbde2']
export const yellowToPurple = ['#ada120', '#981880']
export const darkPinkToRose = ['#a69b9b', '#ab2367']
export const greetToBrown = ['#3c312a', '#4ce167']